import { ADS_AUDIO_PREROLL_CAP_DURATION, ADS_VIDEO_PREROLL_CAP_DURATION } from '../constants';
export const defaultTargetingParams = {
    ad_rule: '1',
    ad_type: 'audio', // can be overwritten
    env: 'instream', // not to be confused with cust_params.env
    gdfp_req: '1',
    gdpr: '0', // can be overwritten
    impl: 's',
    npa: '1', // can be overwritten
    output: 'vmap',
    sz: '1x1', // can be overwritten
    unviewed_position_start: '1',
    vad_type: 'linear',
    plcmt: '2',
    videoad_skippable: '0',
    vpa: 'auto',
    vpos: 'preroll', // can be overwritten
    wta: '0',
};
export const FREESTAR_ENABLED = 'ads.freestar.enabled';
export const PREROLL_ENABLED = 'ads.preroll.enabled';
export const VIDEO_PREROLL_ENABLED = 'ads.videoPreroll.enabled';
export const MIDROLL_ENABLED = 'ads.midroll.enabled';
export const APS_BIDS_RESPONSE_LOGGING_ENABLED = 'ads.aps.logBidsResponse';
export const PREROLL_VIDEO_APS_SLOT_ID = 'APS_VideoINT_GAM';
// These are QA-only controls to enforce preroll/midroll requests for testing purposes.
// These do not guarantee that a preroll/midroll will be served, they only guarantee that a request wil be made.
// There are separate configs for CHROMECAST because we have to set these on the iOS/Android partner ids, so we are
// adding the `chromecast` prefix to add some helpful context to those teams when they come across them in RadioMill.
// For Prod RM, use the serial-targeting syntax (e.g., `qa.ads.guarantee.preroll.request.serial$2281b7f1-c887-4aa8-8dfc-8353e7f6e64a$`)
export const GUARANTEE_PREROLL = 'qa.ads.guarantee.preroll.request';
export const GUARANTEE_MIDROLL = 'qa.ads.guarantee.midroll.request';
export const GUARANTEE_PREROLL_CHROMECAST = 'chromecast.qa.ads.guarantee.preroll.request';
export const GUARANTEE_MIDROLL_CHROMECAST = 'chromecast.qa.ads.guarantee.midroll.request';
export const adTypes = {
    client: 'client',
    instream: 'instream',
};
export const clientAdTypes = {
    preroll: 'preroll',
    midroll: 'midroll',
    outstream: 'outstream',
};
export const AD_SLOTS = {
    UNSPECIFIED: 'AD_SLOT_UNSPECIFIED',
    PREROLL: 'AD_SLOT_PREROLL',
    MIDROLL: 'AD_SLOT_MIDROLL',
    DISPLAY: 'AD_SLOT_DISPLAY',
    INSTREAM: 'AD_SLOT_INSTREAM',
    NOWPLAYING_MREC_VIDEO: 'AD_SLOT_NOWPLAYING_MREC_VIDEO',
};
export const AD_MEDIUM_TYPES = {
    UNSPECIFIED: 'AD_TYPE_UNSPECIFIED',
    AUDIO: 'AD_TYPE_AUDIO',
    VIDEO: 'AD_TYPE_VIDEO',
    DISPLAY: 'AD_TYPE_DISPLAY',
};
export const CAP_KEY_BY_MEDIUM = {
    video: ADS_VIDEO_PREROLL_CAP_DURATION,
    audio: ADS_AUDIO_PREROLL_CAP_DURATION,
};
export const ONE_HOUR_IN_MILLISECONDS = 3600000;
export const COMPANION_AD_SIZES = [
    {
        width: 300,
        height: 600,
    },
    {
        width: 300,
        height: 250,
    },
    {
        width: 728,
        height: 90,
    },
];
